import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .menu-item, .header-phone-link': {
      fontSize: '16px !important',
    },
    '& .topbar-listitem': {
      padding: '0px 10px !important',
    },
    '& .MuiToolbar-root': {
      minHeight: '72px',
    },
  },

  '.group-parent-container': {
    '& .topbar-listitem': {
      '& .MuiButtonBase-root': {
        textTransform: 'none',
      },
    },
    '& .normal-text': {
      fontWeight: 500,
      fontFamily: 'OpenSans-SemiBold !important',
      fontSize: '64px !important',
      lineHeight: '72px !important',
      letterSpacing: '-0.64px !important',
      '@media (min-width: 600px) and (max-width: 1024px)': {
        fontSize: '52px !important',
        lineHeight: '64px !important',
        letterSpacing: '-1.04px !important',
      },
      '@media (max-width: 600px)': {
        fontSize: '44px !important',
        lineHeight: '48px !important',
        letterSpacing: '-0.88px !important',
      },
    },
    '& .hero-home-button': {
      color: palette.text.highlight,
      borderColor: palette.text.highlight,

      '&:hover': {
        borderColor: palette.text.highlight,
      },
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section,.faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
    {
      marginTop: 88,
      backgroundSize: 'cover',
      '& .hero-header-title': {
        fontFamily: 'OpenSans-SemiBold !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        '@media(max-width: 600px)': {
          fontSize: '32px !important',
        },
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '36px !important',
        },
      },
      '& .hero-header-subtitle': {
        fontFamily: 'InterDisplay-Regular !important',
        fontSize: '20px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.8px !important',
        '@media(max-width: 600px)': {
          fontSize: '18px !important',
        },
      },


      '& h1,& h2,& h3,& h4,& p': {
        color: palette.text.highlight,
      },
    },

    '& .subscription-wrapper, .addonsWrapper, .plan-selection-container': {
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
      },
      '& .MuiSwitch-track': {
        border: 'none',
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-variant-2': {
      marginTop: '80px',
    },
    '& .home-hero-wrapper': {
      backgroundColor: palette.background.hero1,
      '@media(max-width: 1200px) and (min-width: 900px)': {
         maxHeight: '600px !important',
      },
      '@media(max-width: 600px)': {
        backgroundColor: palette.background.hero1,
        paddingTop: '40px !important',
      },
      '& .hero-background': {
        objectFit: 'contain',
        backgroundColor: palette.background.hero1,
        '@media screen and (max-width: 600px)': {
          height: '440px',
        },
        '@media(max-width: 900px)': {
          objectFit: 'cover',
        },
        '@media screen and (min-width: 1800px)': {
          objectFit: 'contain',
        },
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '700px',
        '& .section-alternate__content': {
          backgroundColor: palette.background.hero1,
          '@media(max-width: 1200px)': {
            width: '100% !important',
            padding: '0px 50px !important',
            paddingRight: '0px !important',
          },
          '@media(max-width: 600px)': {
            padding: '0px 10px !important',
          },
        },
        '& .section-header': {
          '@media screen and (min-width: 768px)': {
            marginTop: '60px',
          },
          '& .section-header__cta-container': {
            '& .MuiButton-root': {
              fontSize: '16px !important',
            },
            '& .MuiButton-outlinedPrimary': {
              color: palette.text.primaryInverse,
            },
            '@media(max-width: 600px)': {
              justifyContent: 'center !important',
            },
          },
          '& .section-header__title-wrapper': {
            paddingBottom: '24px !important',
          },
        },
      },
      '& .home-hero-title': {
        fontSize: '64px !important',
        fontFamily: 'OpenSans-SemiBold',
        maxWidth: 634,
        lineHeight: '72px !important',
        letterSpacing: '-1.28px',
        '@media(max-width: 1024px) and (min-width: 600px)': {
          fontSize: '52px !important',
          lineHeight: '64px !important',
          letterSpacing: '-1.04px !important',
        },
        '@media(max-width: 600px)': {
          lineHeight: '48px !important',
          fontSize: '44px !important',
          letterSpacing: '-0.72px !important',
          textAlign: 'center !important',
        },
      },
      '& .home-hero-subtitle': {
        maxWidth: 550,
        fontFamily: 'InterDisplay-Regular',
        lineHeight: '28px !important',
        fontSize: '24px !important',
        letterSpacing: '-0.48px !important',
        color: palette.text.tertiary,
        '@media(max-width: 600px)': {
          fontSize: '18px !important',
          textAlign: 'center !important',
        },
      },
      '@media screen and (max-width: 900px)': {
        '& .home-hero-title': {
          fontSize: '2.5rem !important',
        },
        '& .home-hero-subtitle': {
          fontSize: 16,
          fontFamily: 'InterDisplay-Regular',
          maxWidth: 550,
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      background: palette.background.tableSubhead,
      '& .definition-variant-2': {
        padding: '80px !important',
        '@media(max-width: 1200px)': {
          padding: '64px 48px !important',
        },
        '@media(max-width: 900px)': {
          padding: '48px 16px !important',
        },
        '@media(max-width: 600px)': {
          padding: '40px 16px !important',
        },
      },
      '& .section-alternate__content': {
        padding: '0 !important',
        maxWidth: '1280px',
        margin: '0 auto',
      },
      '& .benefits-wrapper': {
        padding: 0,
      },
      '& .section-header': {
        marginBottom: 0,
      },
      '& .section-header__subtitle-wrapper': {
        display: 'none',
      },
      '& .definition-benefits-grid': {
        marginTop: '72px !important',
        justifyContent: 'flex-start',
        '& > .MuiGrid-item': {
          padding: '16px !important',
        },
      },
      '& .definition-service-tile': {
        maxWidth: 'none !important',
        padding: '0 !important',
        height: '100%',
        '& .definition-service-innertile': {
          background: palette.text.highlight,
          borderRadius: '24px',
          padding: '40px 32px !important',
          height: '100%',
          flexDirection: 'column !important',
          alignItems: 'flex-start !important',
          justifyContent: 'flex-start !important',
          margin: '0 !important',
        },
      },
      '& .customIcon': {
        justifyContent: 'flex-start !important',
        paddingBottom: '40px !important',
        maxWidth: 'none !important',
        flexBasis: 'auto !important',
        '& img, & .image': {
          width: '72px !important',
          height: '72px !important',
        },
      },
      '& .definition-service-title': {
        fontFamily: 'OpenSans-SemiBold !important',
        fontSize: '28px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.56px !important',
        textAlign: 'left !important',
        paddingBottom: '16px !important',
        color: palette.text.tertiary,
        '@media(max-width: 600px)': {
          fontSize: '24px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.48px !important',
        },
      },
      '& .definition-service-description': {
        marginBottom: 0,
        fontFamily: 'InterDisplay-Regular !important',
        fontSize: '18px !important',
        lineHeight: '22px !important',
        color: palette.text.tertiaryLight,
        textAlign: 'left !important',
        letterSpacing: '-0.36px !important',
      },
      '& .section-header__title': {
        fontWeight: 500,
        whiteSpace: 'pre-line',
        fontFamily: 'OpenSans-SemiBold !important',
        fontSize: '52px !important',
        lineHeight: '56px !important',
        letterSpacing: '-1.04px !important',
        paddingBottom: '0 !important',
        textAlign: 'left !important',
        color: palette.text.primary,
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '48px !important',
          lineHeight: '48px !important',
          letterSpacing: '-0.96px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '40px !important',
          lineHeight: '44px !important',
          letterSpacing: '-0.88px !important',
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      padding: '0px 16px !important',
      '& .subscription-bg': {
        height: '100%',
        background: palette.surface.pricing,
        backgroundRepeat: 'no-repeat, no-repeat',
      },
      '& .subscription-tabs-label': {
        color: `${palette.text.primaryInverse} !important`,
      },
      '& .section-header__title': {
        color: `${palette.text.highlight} !important`,
        fontWeight: 500,
        fontFamily: 'OpenSans-SemiBold !important',
        fontSize: '56px !important',
        lineHeight: '64px !important',
        letterSpacing: '-1.68px !important',
        whiteSpace: 'pre-line',
        '@media(max-width: 600px)': {
          fontSize: '40px !important',
          lineHeight: '44px !important',
          letterSpacing: '-0.88px !important',
        },
      },
      '& .section-header__subtitle': {
        fontWeight: 400,
        fontFamily: 'InterDisplay-Regular !important',
        fontSize: '18px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        color: palette.text.highlight,
        '@media screen and (max-width: 700px)': {
          fontSize: '18px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
        },
      },
      '& .summary-text, & .summary-subtext': {
        display: 'none !important',
      },
      '& #pricing-benefit-section': {
        '& .carousel-single-item > .MuiGrid-root': {
          '@media(max-width: 1024px)': {
            minWidth: '100% !important',
          },
        },
        '& .planCard': {
          width: '100% !important',
          fontWeight: 400,
          '& .MuiTypography-body2': {
            fontSize: '16px !important',
            lineHeight: '20px !important',
            letterSpacing: '-0.32px !important',
            color: palette.text.primary,
          },
          borderRadius: '12px !important',
          border: 'none !important',
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
            '& hr': {
              color: palette.text.secondary,
            },
          },
          '& .customSubscriberName': {
            fontSize: '16px !important',
            color: palette.text.tertiary,
          },
          '& .MuiButton-containedPrimary': {
            backgroundColor: palette.background.light,
            color: palette.text.primary,
            '&:hover': {
              backgroundColor: palette.primary.main,
              color: palette.text.highlight,
              transition: 'none !important',
            },
          },
          '& .planCardHeaderContainer': {
            marginBottom: '24px !important',
          },
          '& .customcardTitle': {
            fontFamily: 'OpenSans-SemiBold !important',
            fontSize: '28px !important',
            lineHeight: '32px !important',
            letterSpacing: '-0.64px !important',
            color: palette.text.primary,
          },
          '& .price-value': {
            fontSize: '32px !important',
            fontFamily: 'OpenSans-SemiBold !important',
            lineHeight: '40px !important',
            letterSpacing: '-0.8px !important',
            color: palette.text.primary,
          },
          '& .price-frequency, & .display-frequency': {
            fontSize: '16px !important',
            lineHeight: '20px !important',
            letterSpacing: '-0.32px !important',
            color: palette.text.tertiary,
          },
          '& .customUpfrontWrapper': {
            color: palette.text.tertiaryLight,
            fontWeight: 400,
            lineHeight: '16px !important',
            letterSpacing: '-0.42px !important',
            fontStyle: 'italic',
          },
        },
        '& .disclaimerContainer': {
            '& .customUpfrontWrapper': {
              paddingLeft: '15px !important',
              width: '100% !important',
            },
            '& .disclaimerText': {
              fontSize: '14px !important',
              color: `${palette.text.secondary} !important`,
            },
            '& .bold': {
              fontSize: '14px !important',
              lineHeight: '20px !important',
              color: `${palette.text.secondary} !important`,
              fontStyle: 'italic',
              fontFamily: 'InterDisplay-Regular !important',
            },
          },
        '& .subscription-section': {
          objectFit: 'cover',
          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
            '@media(max-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .plans-loader': {
            color: palette.text.highlight,
          },
        },
        '& .bold': {
          fontWeight: 500,
          fontSize: '24px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.48px !important',
          color: `${palette.text.tertiary} !important`,
          fontFamily: 'OpenSans-SemiBold !important',
          '@media screen and (max-width: 700px)': {
            fontSize: '20px !important',
          },
        },
        '& .summary-text, & .summary-subtext': {
          display: 'none !important',
        },
        '& .savings-summary-link': {
          color: `${palette.text.brand} !important`,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.background.main,
      '& .section': {
        '@media(min-width: 600px) and (max-width: 1024px)': {
          padding: '40px !important',
        },
        '@media(min-width: 1024px)': {
          padding: '40px 80px !important',
        },
        '@media(max-width: 600px)': {
          padding: '24px 20px !important',
        },
      },

      '& .cover-image-wrapper': {
        display: 'flex !important',
        justifyContent: 'center',
        alignItems: 'stretch',
        width: '100% !important',
        overflow: 'hidden',
        position: 'relative',
        borderRadius: '24px !important',
        '@media(min-width: 600px) and (max-width: 1024px)': {
          height: '500px !important',
          minHeight: '500px !important',
        },
        '@media(min-width: 1024px)': {
          height: '560px !important',
          minHeight: '560px !important',
        },
        '@media(max-width: 600px)': {
          height: '382px !important',
          minHeight: '382px !important',
        },
        '& img, & .image, & .how-cover-image': {
          width: '100% !important',
          height: '100% !important',
          minHeight: '100% !important',
          objectFit: 'cover !important',
          display: 'block !important',
          position: 'absolute',
          top: 0,
          left: 0,
        },
      },
      '& .howitworks-title': {
        '& .section-header__title': {
          whiteSpace: 'pre-line',
          fontFamily: 'OpenSans-SemiBold !important',
          fontSize: '52px !important',
          lineHeight: '56px !important',
          letterSpacing: '-1.04px !important',
          '@media(max-width: 600px)': {
            fontSize: '44px !important',
            lineHeight: '44px !important',
            letterSpacing: '-0.88px !important',
          },
        },
        '& .section-header__subtitle': {
          fontWeight: 400,
          fontSize: '24px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.48px !important',
          '@media(max-width: 1200px)': {
            fontSize: '20px !important',
          },
        },
        marginBottom: 40,
      },

      '& .howitworks-wrapper': {
        padding: 20,
      },

      '& .howitworks-wrapper-left': {
        padding: 20,
        paddingLeft: '0 !important',
        '@media(max-width: 1000px)': {
          paddingTop: '40px !important',
        },
      },

      '& .makeStyles-root-54': {
        padding: 0,
      },

      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: palette.primary.main,
        color: palette.text.highlight,
        fontSize: 15,
      },

      '& .working-steps-container': {
        '@media(min-width: 900px)': {
          maxWidth: '560px',
        },
        '&:not(:last-child)': {
          borderBottom: `1px solid ${palette.background.border} !important`,
          paddingBottom: '24px !important',
        },
        '& .step-title': {
          fontSize: 24,
          lineHeight: '24px !important',
          letterSpacing: '-0.48px !important',
          fontFamily: 'OpenSans-SemiBold !important',
          paddingBottom: '8px !important',
          '@media(max-width: 600px)': {
            fontSize: '22px !important',
            lineHeight: '24px !important',
            letterSpacing: '-0.44px !important',
          },
        },
        '& .step-content': {
          fontSize: 18,
          color: palette.text.tertiaryLight,
          lineHeight: '22px !important',
          letterSpacing: '-0.36px !important',
        },
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },

      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 30,
      },

      '@media screen and (max-width: 900px)': {
        '& .howitworks-wrapper-left': {
          padding: '5px',
        },
      },

      '@media(min-width: 900px)': {
        '& .howitworks-wrapper-left': {
          paddingLeft: '40px',
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .savings-hero-section': {
        backgroundSize: 'cover',
      },
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.primary.main} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },
        '& .savings-cell':{
          color: palette.text.primary,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .savings-contact-card': {
        padding: '0px 0px 0px 0px !important',
        backgroundColor: palette.surface.light,
      },

      '& .footer-bar': {
        backgroundColor: `${palette.background.secondaryLight} !important`,
      },

      '& .footer-bar-text': {
        color: palette.text.primary,
      },
      '& .MuiButton-containedSecondary': {
        backgroundColor: palette.primary.main,
        color: palette.text.highlight,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: `${palette.primary.main} !important`,
      },
      '& .section-alternate': {
        position: 'relative',
        zIndex: 1,
        '& .section-alternate__content': {
          padding: '48px 80px !important',
          maxWidth: '1280px',
          margin: '0 auto',
          '@media(max-width: 1200px)': {
            padding: '48px 48px !important',
          },
          '@media(max-width: 900px)': {
            padding: '48px 16px !important',
          },
        },
      },
      '& .hero-static-section-grid': {
        alignItems: 'center !important',
      },
      '& .section-header': {
        marginBottom: 0,
      },
      '& .section-header__title-wrapper': {
        marginBottom: '8px !important',
      },
      '& .section-header__title': {
        color: `${palette.text.highlight} !important`,
        fontFamily: 'OpenSans-SemiBold !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        '@media screen and (max-width: 600px)': {
          fontSize: '32px !important',
          lineHeight: '36px !important',
        },
      },
      '& .section-header__subtitle': {
        color: `${palette.text.highlight} !important`,
        fontFamily: 'InterDisplay-Regular !important',
        fontSize: '18px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.8px !important',
      },
      '& .hero-button-wrapper': {
        '@media(min-width: 900px)': {
          display: 'flex !important',
          justifyContent: 'flex-end !important',
        },
        '@media(max-width: 900px)': {
          display: 'flex !important',
          justifyContent: 'center !important',
        },
      },
      '& .primary-static-button': {
        backgroundColor: `${palette.background.light} !important`,
        color: `${palette.text.primary} !important`,
        fontFamily: 'InterDisplay-Regular !important',
        fontWeight: 600,
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.32px !important',
        textTransform: 'uppercase',
        padding: '12px 32px !important',
        borderRadius: '4px !important',
        boxShadow: 'none !important',
        minWidth: '120px',
        '&:hover': {
          backgroundColor: `${palette.background.light} !important`,
          opacity: 0.9,
        },
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .checkout-innner-container': {
        '& .customDetailsContainer': {
          '& .MuiButtonBase-root': {
            textTransform: 'none !important',
          },
        },
      },
      '& .hero-header-title': {
        fontFamily: 'OpenSans-SemiBold !important',
        fontSize: '48px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.96px !important',
        fontWeight: 500,
      },
      '& .hero-header-subtitle': {
        fontFamily: 'InterDisplay-Regular !important',
        fontSize: '18px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 400,
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        background: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.primary.main} !important`,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .MuiButton-contained': {
        backgroundColor: palette.text.highlight,
        color: palette.text.primary,
      },
      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        maxWidth: 'unset',
      },
      '& .header-container': {
        margin: '0',
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '10px',
          padding: '64px 24px !important',
        },
      },
    },
    '& .faqInnerContainer': {
      '& .Mui-selected': {
        backgroundColor: palette.surface.grey,
        color: palette.text.primary,
      },
      '& .faq-link': {
        fontSize: '15px !important',
      },
      '& .accorion__item-title-container': {
        '& .MuiTypography-subtitle1': {
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.8px !important',
          fontWeight: 500,
        },
      },
      '& .accordion__collapsable-text': {
        color: palette.text.tertiary,
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.32px !important',
      },
    },
    '& .faq-contact-section': {
      background: `${palette.background.light} !important`,
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      paddingInline: '80px !important',
      '@media(max-width: 1024px) and (min-width: 900px)': {
        paddingInline: '20px !important',
      },
      '@media(max-width: 900px) and (min-width: 600px)': {
        paddingInline: '40px !important',
      },
      '@media(max-width: 600px) ': {
        paddingInline: '20px !important',
      },
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
        padding: '0px !important',
        paddingRight: '8px !important',
      },
      '& .contact-card-title': {
        fontFamily: 'OpenSans-SemiBold !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        '@media(max-width: 600px)': {
          fontSize: '32px !important',
        },
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '36px !important',
        },
      },
      '& .contact-card-subtitle': {
        color: palette.text.primary,
        fontSize: '24px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        maxWidth: 'unset',
      },
      '& .provider-contact-details': {
        fontSize: '18px !important',
        fontFamily: 'InterDisplay-Regular !important',
        lineHeight: '18px !important',
        letterSpacing: '-0.36px !important',
        color: palette.text.primary,
        paddingBottom: '5px !important',
      },
      '& .provider-contact-link': {
        color: palette.text.primary,
        fontSize: 24,
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        fontFamily: 'InterDisplay-Regular !important',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
        maxWidth: '100%',
        paddingTop: '5px',
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'OpenSans-SemiBold',
        fontWeight: 500,
      },
    },

    '& .success-wrapper': {
      marginTop: 120,
      '& .MuiButton-containedPrimary': {
        background: `${palette.background.main} !important`,
        color: `${palette.text.primary} !important`,
        border: `1px solid ${palette.primary.main} !important`,
      },  
      '& .MuiButton-containedSecondary': {
        background: `${palette.primary.main} !important`,
        color: `${palette.text.highlight} !important`,
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.background.light,
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
      backgroundColor: palette.primary.main,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      maxWidth: '598px',
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.surface.light,
      },
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.border ,
        color: palette.background.border,
      },
    },

    // Stepper Icon Styles - Completed vs Uncompleted
    '& .MuiStepIcon-root': {
      color: 'transparent', // Default: transparent background
      width: 32,
      height: 32,
      borderColor: palette.primary.main,

      // Completed step - filled circle with checkmark
      '&.MuiStepIcon-completed': {
        fill: `${palette.primary.main} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
      },

      // Active step - filled circle with number
      '&.MuiStepIcon-active': {
        fill: `${palette.primary.main} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.highlight, // White text on filled background
        },
      },

      // Uncompleted step - empty circle with number
      '&:not(.MuiStepIcon-completed):not(.MuiStepIcon-active)': {
        '& .MuiSvgIcon-root': {
          color: 'transparent',
        },
        '& .MuiStepIcon-text': {
          fill: palette.primary.main  , // Dark text on transparent background
        },
      },
    },

    // Stepper Label Styles
    '& .MuiStepLabel-label': {
      color: palette.text.primary,

      '&.MuiStepLabel-completed': {
        color: palette.text.primary,
        fontWeight: 500,
      },

      '&.MuiStepLabel-active': {
        color: palette.text.primary,
        fontWeight: 500,
      },
    },

    // Stepper Connector Line
    '& .MuiStepConnector-lineHorizontal': {
      borderColor: `${palette.background.border} !important`,
      borderTopWidth: 2,
    },

    // Stepper Container Style
    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        display: 'none',
      },
    },

    '& .stepperItems': {
      marginTop: 24,
    },

    '& .footer-wrapper': {
      backgroundColor: palette.background.footer,
      paddingInline: '40px !important',
      '@media(max-width: 700px)': {
        paddingInline: '10px !important',
      },
    },
  },
};
